import { SUBTYPE_LABELS } from "../RankingsTab/RankingsTab";

export const SUBTYPES = Object.keys(SUBTYPE_LABELS);

export const SUBMISSION_TYPES = [
  { value: "", label: "None" },
  { value: "firm", label: "Firm" },
  { value: "lawyer", label: "Lawyer" },
];

export const REFEREE_TYPES = [
  { value: "", label: "None" },
  { value: "firm", label: "Firm" },
  { value: "lawyer", label: "Lawyer" },
];

export function defaultSubmissionType(subtype: string): string {
  if (subtype === "firm_recommended") return "firm";
  if (subtype === "lawyer_recommended") return "lawyer";
  return "";
}

export { SUBTYPE_LABELS };
